import constants from '../../../common/constants';
import { Box, Button, Grid, Icon } from '@amzn/awsui-components-core';
import RouterPaths from '../../../common/RouterPaths';
import BrowserHistory from '../../utils/BrowserHistory';
import { ContentSubType } from '@amzn/awscat-pattern-library-service-model';
import ManageUserProfileLink from '../../apgl-user-profile/ManageUserProfileLink';

const HomePageBanner = () => {
  const handleCreateContent = () => {
    BrowserHistory.push(RouterPaths.CREATE_CONTENT);
  };

  const handleLearnAboutAPG = () => {
    BrowserHistory.push(RouterPaths.WHATS_NEW, { postType: ContentSubType.GettingStarted });
  };

  return (
    <div className="custom-home__header banner-bkg">
      <Box variant="div" margin={{ left: 'xxs' }} padding={{ top: 'm' }} className="banner-text">
        <div className="custom-home__header-title">
          <Grid
            gridDefinition={[
              { colspan: { default: 11, s: 9, m: 7, l: 6 } },
              { colspan: { default: 1, xxs: 1 } },
            ]}
          >
            <div>
              <Box color="inherit" variant="h2" fontWeight="bold">
                <span style={{ color: 'white' }}>{constants.APP_NAME_FULL}</span>
              </Box>

              <Box variant="p" color="inherit" fontSize="heading-m" className="app-desc">
                <Box color="inherit" variant="strong" fontSize="heading-m">
                  Maximize your impact.
                </Box>{' '}
                {constants.APP_DESCRIPTION}
              </Box>

              <div className="home-page-banner-action-container">
                <Button variant="primary" onClick={handleCreateContent}>
                  Create content
                </Button>
                <Box padding={{ left: 'm' }}>
                  <div onClick={handleLearnAboutAPG} className="home-page-banner-action-link">
                    Learn about APG Library{' '}
                    <Icon name="angle-right" size="small" variant="inverted" />
                  </div>
                </Box>
                <Box padding={{ left: 'm' }}>
                  <ManageUserProfileLink />
                </Box>
              </div>
            </div>
            <div />
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default HomePageBanner;
